import React, { useState, useEffect } from 'react';

const StoreDropdown = ({ selectedStore, onStoreChange }) => {
    const [stores, setStores] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchStores();
    }, []);

    const fetchStores = async () => {
        try {
            const response = await fetch('https://doticom.vn:3000/stores');
            const data = await response.json();
            setStores(data);
        } catch (error) {
            console.error('Error fetching stores:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{ position: 'relative' }}>
            <select 
                value={selectedStore} 
                onChange={(e) => onStoreChange(e.target.value)}
                className="form-control"
                disabled={loading}
                style={{ 
                    fontSize: '14px',
                    paddingLeft: '40px'
                }}
            >
                <option value="">
                    {loading ? 'Đang tải danh sách cửa hàng...' : '-- Chọn cửa hàng nhận hàng --'}
                </option>
                {stores.map(store => (
                    <option key={store.IDCH} value={store.IDCH}>
                        {store.TenCuaHang}
                    </option>
                ))}
            </select>
            <i className="fas fa-building" style={{
                position: 'absolute',
                left: '12px',
                top: '50%',
                transform: 'translateY(-50%)',
                color: '#6c757d',
                fontSize: '14px'
            }}></i>
            {loading && (
                <div className="spinner-border spinner-border-sm" style={{
                    position: 'absolute',
                    right: '12px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    width: '16px',
                    height: '16px'
                }}></div>
            )}
        </div>
    );
};

export default StoreDropdown;
